import { useSendHeartbeat } from '@/api/callcenter/dashboard/sendHeartbeat';
import { useWorkerInterval } from './useWorkerInterval';

export const HEARTBEAT_INTERVAL_MS = 60_000;

/**
 * Sends the callcenter dashboard heartbeat every HEARTBEAT_INTERVAL_MS while
 * `enabled` — visible or not. The heartbeat is a presence signal: agents work
 * calls in the BrightPattern window with this tab backgrounded, and browser
 * background-tab throttling was silencing the beat until the server read the
 * dashboard as abandoned (see useWorkerInterval for the mechanism). Activity
 * pings stay visibility-gated on purpose — "the dashboard is open" and "the
 * agent is looking at this lead" are different claims. Pure composition:
 * retry, silent-failure, and feed_paused reconciliation all live in
 * useSendHeartbeat and must not be duplicated here.
 */
export const useCallCenterHeartbeat = (enabled = true) => {
  const { mutate } = useSendHeartbeat();

  useWorkerInterval(() => mutate(), HEARTBEAT_INTERVAL_MS, enabled);
};
